import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, NgModule } from '@angular/core';
import * as i2 from '@adeo/ngx-kozikaza-api';
import { BaseService, KOZIKAZA_API_OPTIONS } from '@adeo/ngx-kozikaza-api';
import * as i1 from '@angular/common/http';

class CountryLegacyService extends BaseService {
    platformId;
    static endpoint = '/countries';
    getWebServiceName() {
        return 'CountryLegacyWebService';
    }
    constructor(options, httpClient, platformId, cache, logger) {
        super(options, httpClient, platformId, cache, logger);
        this.platformId = platformId;
    }
    getCountries(options) {
        return this.getNoHydraMember(`${CountryLegacyService.endpoint}`, options);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyService, deps: [{ token: KOZIKAZA_API_OPTIONS }, { token: i1.HttpClient }, { token: PLATFORM_ID }, { token: i2.CacheService }, { token: i2.Logger }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyService });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [KOZIKAZA_API_OPTIONS]
                }] }, { type: i1.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [PLATFORM_ID]
                }] }, { type: i2.CacheService }, { type: i2.Logger }]; } });

const WEB_SERVICES = [
    CountryLegacyService,
];
class CountryLegacyApiModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyApiModule });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyApiModule, providers: [
            ...WEB_SERVICES,
        ] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.8", ngImport: i0, type: CountryLegacyApiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [],
                    providers: [
                        ...WEB_SERVICES,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CountryLegacyApiModule, CountryLegacyService };
